import { Box, styled } from "@mui/material";

export const CustomTagsBox = styled(Box)({
    display: "block",
    "& .MuiListItemButton-root": { paddingLeft: "3rem" },
});
